import { Box, Typography } from "@material-ui/core";
import React, { useRef, useState } from "react";

import MenuPopover from "../components/MenuPopover";

const AccountPopover = ({ orgLabel, eventName, children }) => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  //...
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  // ...
  //? ==========================================================================
  //? `REACT_APP_ORG_ADMIN_URL` — LE RENVOI « MY ORGANISATION » VERS LA NOUVELLE
  //? INTERFACE, ET POURQUOI C'EST UNE VARIABLE DE PLUS ET NON UN ÉCHANGE
  //? D'ORIGINE SUR `REACT_APP_EVEY_URL`.
  //? ==========================================================================
  //? Retour QA du 17/09 : « lorsque l'organisateur est dans la partie setup d'un
  //? événement et clique sur my organisation, il doit être redirigé vers la
  //? nouvelle interface admin d'Eveynext (overview, community, events,..) ». Ce
  //? lien ouvrait `evey.live/profile/my-organization`, l'ANCIENNE interface.
  //?
  //? ⚠️ REPOINTER `REACT_APP_EVEY_URL` EN BLOC EST LA MAUVAISE RÉPONSE. Trois
  //? mesures du 17/09, chacune suffisante :
  //?   1. LE CHEMIN N'EXISTE PAS dans le nouveau front : aucune route
  //?      `/profile/*` (`evey.next/src/app` n'a pas de dossier `profile`) et
  //?      aucun rewrite dans son `next.config.mjs`. L'écran équivalent est
  //?      `/account/organization`, qui ouvre Overview par défaut
  //?      (`account/organization/page.js:177`) — exactement ce que demande le
  //?      recetteur. Échanger l'origine seule donnerait un 404.
  //?   2. LA MÊME VARIABLE SERT SIX AUTRES ENDROITS, dont un qu'on casserait :
  //?      `views/EventSetup/tabs/Info.js:63` construit
  //?      `…/profile/my-organization?goTo=payment` — le lien « Stripe account ».
  //?      Dans evey.next l'onglet `payment` est explicitement hors périmètre
  //?      (`account/organization/page.js:156`) et un `?goTo=payment` retombe
  //?      SILENCIEUSEMENT sur Overview ; Stripe n'accepte en plus que les
  //?      `redirect_uri` déclarés dans son tableau de bord, et c'est
  //?      `/profile/my-organization` qui y est déclaré. Ce lien RESTE sur
  //?      evey.live.
  //?   3. Les autres usages (page publique d'un événement, presse-papier de
  //?      publication) sont légitimes sur evey.live.
  //?
  //? ADDITIF ET RÉTRO-COMPATIBLE — motif repris de `INVITATION_FRONT_URL`
  //? (`evey.api/config/server.js`, 16/09) : défaut VIDE, pour que « non
  //? renseignée » se teste d'un seul `!!`, et branche de repli qui est l'ANCIEN
  //? CODE MOT POUR MOT. Un déploiement qui ignore la variable ouvre exactement
  //? la même URL qu'avant. ⚠️ Ce module EST déployé (`setup.evey.live`).
  //?
  //? ⚠️ ET SURTOUT : AUCUN `return` QUI SAUTERAIT `window.open`. Un bouton
  //? inerte serait pire que le défaut signalé — ce module a déjà eu un bouton
  //? figé sur `disabled` que personne ne pouvait déclencher. Même
  //? `REACT_APP_EVEY_URL` absente (aucun `.env` n'est livré dans ce dépôt), on
  //? ouvre l'onglet comme avant plutôt que de ne rien faire.
  //?
  //? L'ORIGINE SEULE EST RÉGLABLE, LE CHEMIN EST ÉCRIT ICI : les deux ne peuvent
  //? pas être dissociés sans permettre la combinaison qui 404 (nouvelle origine
  //? + ancien chemin, ou l'inverse), qui est précisément ce que ce correctif
  //? existe pour empêcher. CRA inline `process.env.REACT_APP_*` À LA
  //? COMPILATION : la variable doit exister dans l'environnement qui lance
  //? `react-scripts build`, elle n'est pas réglable au runtime.
  //?
  //? Aucun paramètre n'est transmis, et notamment PAS le JWT : evey.next tient
  //? sa propre session, et la mesure du 15/09 citée par `INVITATION_FRONT_URL`
  //? montre que son framework sérialise toute chaîne de requête DEUX FOIS dans
  //? le document servi — un jeton y entrerait dans le HTML et les journaux.
  const onNavigateToOrgProfile = () => {
    const ORG_ADMIN_URL = process.env.REACT_APP_ORG_ADMIN_URL;
    if (ORG_ADMIN_URL) {
      //? Barre oblique finale retirée : `https://x/` + `/account/…` donnerait
      //? `//account/…`, soit un 404 silencieux pour une faute d'exploitation.
      const link = `${ORG_ADMIN_URL.replace(/\/+$/, "")}/account/organization`;
      window.open(link, "_blank");
      return;
    }
    // ...
    const LIVE_URL = process.env.REACT_APP_EVEY_URL;
    const link = `${LIVE_URL}/profile/my-organization`;
    window.open(link, "_blank");
  };
  // ...
  return (
    <Box className="DashboardNavbarPopover">
      <Box ref={anchorRef} onClick={handleOpen}>
        {children}
      </Box>

      <MenuPopover
        open={open}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        sx={{ width: 220 }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography
            className="DashboardNavbarPopover__org"
            variant="subtitle1"
            noWrap
            onClick={onNavigateToOrgProfile}
          >
            {orgLabel}
          </Typography>
          <Typography
            className="DashboardNavbarPopover__event"
            variant="body2"
            sx={{ color: "text.secondary" }}
            noWrap
          >
            {eventName}
          </Typography>
        </Box>
      </MenuPopover>
    </Box>
  );
};

export default AccountPopover;
